import React from 'react';
import styles from './FaqSection.module.css';
import Monogram from "assets/images/monogram.png";
import { useTranslation } from 'react-i18next';

const FaqSection = () => {
    const { t } = useTranslation();

    return (
        <section className={styles['faq-section']} >
        <div className={styles['faq-container']}>
        <div className={styles['faq-content']}>
            <div className={styles['faq-image']}>
                <img src={Monogram} alt="monogram" className={styles['monogram-image']} />
            </div>
            <h1 className={styles['faq-title']}>
              {t('faq.title')}  
            </h1>
        </div>
        </div>
        </section>
    );
};

export default FaqSection;